export default __webpack_public_path__ + "static/media/kitchen5-beforeB-768w.ca114b4a.avif";